module.exports = __webpack_public_path__ + "static/img/图层4.80fc7b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层4.png
// module id = Cwn3
// module chunks = 0